import React from 'react';
import styled from '@emotion/styled';

const HeroSection = styled.section`
  padding: 150px 24px 0px;
  text-align: center;
  background: linear-gradient(180deg, #f3efff 0%, #ffffff 100%);
  position: relative;
  overflow: hidden;
`;

const Container = styled.div`
  margin: 0 auto;
`;

const Badge = styled.div`
  display: inline;
`;

const BadgeText = styled.span`
  font-size: 12px;
  font-weight: 800;
  color: #6d4aff;
  text-transform: uppercase;
  letter-spacing: 0.16em;
`;

const Title = styled.h1`
  font-family: 'Space Grotesk', sans-serif;
  max-width: 44.2rem;
  margin: 14px auto;
  font-size: clamp(2.6rem, 7vw, 4rem);
  font-weight: 700;
  line-height: .94;
  color: #0f1116;
  letter-spacing: -0.04em;
  text-wrap: balance;

  span {
    color: #7664c6;
  }

`;

const Subtitle = styled.p`
  font-size: 18px;
  line-height: 1.7;
  color: #5f5a70;
  max-width: 680px;
  margin: 0 auto;
`;

const PricingHero: React.FC = () => {
  return (
    <HeroSection>
      <Container>
        <Badge>
          <BadgeText>Simple, Transparent Pricing</BadgeText>
        </Badge>

        <Title>
          Enterprise power,<br />
          <span>startup pricing.</span>
        </Title>

        <Subtitle>
          Everything you need to automate support, capture leads, and grow your business.
          No hidden fees, no surprise charges.
        </Subtitle>

      </Container>
    </HeroSection>
  );
};

export default PricingHero;
